import React from 'react';

const Navbar = () => {
    return (
        <div>
            hello jabbar
        </div>
    );
};

export default Navbar;